/**
 * Strike-off (compare-at) price is optional. APIs often send 0 / "0.00" / "$0"
 * when the vendor did not set one — those must not render as a list price.
 */

export function parsePositivePrice(raw: unknown): number | null {
  if (raw === null || raw === undefined || raw === '') {
    return null;
  }
  const n = parseFloat(String(raw).replace(/[$,\s]/g, ''));
  if (!Number.isFinite(n) || n <= 0) {
    return null;
  }
  return n;
}

export function hasDisplayStrikeoffPrice(raw: unknown): boolean {
  return parsePositivePrice(raw) != null;
}

/** Formatted "$12.00" when a real strike-off exists; otherwise undefined. */
export function formatStrikeoffPriceLabel(raw: unknown): string | undefined {
  const n = parsePositivePrice(raw);
  return n == null ? undefined : `$${n.toFixed(2)}`;
}

/** Raw strike-off for formatPrice(); empty when the vendor did not provide one. */
export function strikeoffPriceOrEmpty(raw: unknown): string {
  const n = parsePositivePrice(raw);
  return n == null ? '' : n.toFixed(2);
}
